import '../../sass/layout/sections/blog-carousel.scss';

import Swiper, {
    Navigation,
    Autoplay,
    EffectFade
} from 'swiper';
import myLazyLoad from '../vendors/lazyLoading';

const blogCarousel = document.getElementById('blogCarousel');

if (blogCarousel) {
    const prevEl = blogCarousel.querySelector('.swiper-button-prev');
    const nextEl = blogCarousel.querySelector('.swiper-button-next');

    const options = {
        modules: [Navigation, Autoplay, EffectFade],
        loop: false,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl,
            nextEl,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        init: true,
    }

    const swiper = new Swiper(blogCarousel, options);
    
    swiper.on('slideChange', function (swiper) {
        myLazyLoad.update();
    });

}